var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/about/index.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { fetchAboutPage } from 'soapbox/actions/about';
import { useSoapboxConfig, useSettings, useAppDispatch } from 'soapbox/hooks';
import { languages } from '../preferences';
/** Displays arbitary user-uploaded HTML on a page at `/about/:slug` */

const AboutPage = () => {
  const dispatch = useAppDispatch();
  const {
    slug
  } = useParams();
  const settings = useSettings();
  const soapboxConfig = useSoapboxConfig();
  const [pageHtml, setPageHtml] = useState('');
  const [locale, setLocale] = useState(settings.get('locale'));
  const {
    aboutPages
  } = soapboxConfig;
  const page = aboutPages.get(slug || 'about');
  const defaultLocale = page === null || page === void 0 ? void 0 : page.get('default');
  const pageLocales = page === null || page === void 0 ? void 0 : page.get('locales', []);
  useEffect(() => {
    const fetchLocale = Boolean(page && locale !== defaultLocale && pageLocales.includes(locale));
    dispatch(fetchAboutPage(slug, fetchLocale ? locale : undefined)).then(html => {
      setPageHtml(html);
    }).catch(error => {
      // TODO: Better error handling. 404 page?
      setPageHtml('<h1>Page not found</h1>');
    });
  }, [locale, slug]);
  const alsoAvailable = defaultLocale && /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "about.also_available",
    defaultMessage: "Available in:",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }), ' ', /*#__PURE__*/React.createElement("ul", {
    className: "p-0 inline list-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("li", {
    className: "inline after:content-['_\xB7_']",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: () => setLocale(defaultLocale),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 11
    }
  }, languages[defaultLocale] || defaultLocale)), pageLocales === null || pageLocales === void 0 ? void 0 : pageLocales.map(locale => /*#__PURE__*/React.createElement("li", {
    className: "inline after:content-['_\xB7_'] last:after:content-none",
    key: locale,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: () => setLocale(locale),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 15
    }
  }, languages[locale] || locale)))));
  return /*#__PURE__*/React.createElement("div", {
    className: "prose dark:prose-invert mx-auto py-20",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: pageHtml
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 7
    }
  }), alsoAvailable);
};

export default AboutPage;